import { Injectable } from "@angular/core";
import { API_METHODS, API_URL } from "common/constants/sm-constants";
import { environment } from "src/environments/environment";
import { editInfo } from "common/models/utility-models/utility-interface";
import { InternshipDetailsModel } from "common/models/page-models/internship-detail/internship-detail-data.model";
import { FormDataService } from "../../base-data-services/form-data.service";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import moment from "moment";



@Injectable({
    providedIn: 'root'
})
export class InternshipDetailsFormDataService extends FormDataService<InternshipDetailsModel> {
   
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.StudentResponseOnInvite, http, ss);
    }
    
    override getEditUrlAndMethod() {
        const edit = {
            url: environment.apiUrl + API_URL.PreviewStudentInternshipDetailsSuperadmin,
            method: API_METHODS.post
        }
        return edit;
    }

    override getUpdatePayload(data){
        // console.log(data)
        const payload = {
            id: data.id
            // id: 12
        }
        return payload;
    }

    override beforePostData(
        model: any,
        metamodel: any,
        dataModel: any
      ): Promise<InternshipDetailsModel> {
        return new Promise((resolve, reject) => {
          const submitData: any = {};
        //   console.log("Model ",model,dataModel);

          submitData.id = dataModel.detail.id;
          submitData.isStudentAvailable = model.isStudentAvailable;
          submitData.studentExamStartDate = moment(model.semesterExamStart).format("YYYY-MM-DD")
          submitData.studentExamEndDate = moment(model.semesterExamEnds).format("YYYY-MM-DD")
          submitData.studentSummerVacationStartDate = moment(model.summerVacationStarts).format("YYYY-MM-DD")
          submitData.studentSummerVacationEndDate = moment(model.summerVacationEnds).format("YYYY-MM-DD")
          submitData.studentExpectedInternshipStartDate = moment(model.internshipStartDate).format("YYYY-MM-DD")
          submitData.studentExpectedInternshipEndDate = moment(model.internshipEndDate).format("YYYY-MM-DD")

          
          resolve(submitData);
        });
      }
   

    override modifyAPIResponse(response: any) {
        const dataModel = this.createInstance();
        // const dataModel:any = {};
        // const res = {
        //     detail : response.details,
        //     previousdetails: response.previousdetails,
        //     formData: this.createInstance()
        // }

        // res.formData
        // res.formData.id = response.details.id;
        // res.formData.isStudentAvailable = response.details.isStudentAvailable
        // res.formData.semesterExamStart = response.details?.studentExamStartDate ? new Date(response.details.studentExamStartDate) : "";
        // res.formData.semesterExamEnds = response.details?.studentExamEndDate ? new Date(response.details.studentExamEndDate) : "";
        // res.formData.summerVacationStarts =  response.details?.studentSummerVacationStartDate ? new Date(response.details.studentSummerVacationStartDate) : "";
        // res.formData.summerVacationEnds = response.details?.studentSummerVacationEndDate ? new Date(response.details.studentSummerVacationEndDate) : "";
        // res.formData.internshipStartDate = response.details?.studentExpectedInternshipStartDate ? new Date(response.details.studentExpectedInternshipStartDate) : "";
        // res.formData.internshipEndDate = response.details?.studentExpectedInternshipEndDate ? new Date(response.details.studentExpectedInternshipEndDate) : "";
         dataModel.detail = response['details']
        return dataModel;
        // return res;
    }

    override getUpdateUrl() {
        return API_URL.StudentResponseOnInvite;
    }

    createInstance(): InternshipDetailsModel {
        
        return new InternshipDetailsModel();

    }


}

export { FormDataService };
